import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';
import './header.css';

export type ViewMode = 'grid' | 'list';

interface HeaderProps {
    viewMode: ViewMode;
    onViewModeChange: (mode: ViewMode) => void;
    viewingPastReleases: boolean
}

const Header: React.FC<HeaderProps> = ({
    viewMode,
    onViewModeChange,
    viewingPastReleases
}) => {
    const handleViewChange = (
        _event: React.MouseEvent<HTMLElement>,
        newView: ViewMode | null
    ) => {
        if (newView !== null) {
            onViewModeChange(newView);
        }
    };

    return (
        <Box className="header-container">
            <Typography variant="h6" className="header-title">
                {viewingPastReleases ? (
                    <>Past Releases</>
                ) : (
                    <>Product Roadmap</>
                )}
            </Typography>
            <ToggleButtonGroup
                value={viewMode}
                exclusive
                onChange={handleViewChange}
                aria-label="view mode"
                className="header-toggle-group"
            >
                <ToggleButton value="grid" aria-label="grid view" className="header-toggle-button">
                    <GridViewIcon className="header-toggle-icon" />
                    <span className="header-toggle-label">Grid</span>
                </ToggleButton>
                <ToggleButton value="list" aria-label="list view" className="header-toggle-button">
                    <ViewListIcon className="header-toggle-icon" />
                    <span className="header-toggle-label">List</span>
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

export default Header;
